import React from "react";
import {
  Container,
  Box,
  makeStyles,
  Grid,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import Logo from "../assets/images/logo.PNG";
import { useHistory, useLocation } from "react-router-dom";
import SlideDownModal from "../components/reusableComponents/SlideDownModal";
import Footer from "./Desktop/Footer";
import SearchEngine from "../form/SearchEngine";
import HeaderSection from "../components/reusableComponents/HeaderSection";
import { useEffect } from "react";
import { HoldSearchDispatch } from "../reducers/HomeReducer";
import { useDispatch, useSelector } from "react-redux";
import SkeletonOneway from "../components/reusableComponents/SkeletonOneway";
const useStyles = makeStyles(() => ({
  item: {
    //   backgroundColor: "#ee8622",
    display: "flex",
    listStyle: "none",
    marginBottom: 0,
    marginTop: 0,
    "&:hover": {
      backgroundColor: "#ee8622",
    },
  },
  li: {
    color: "white",
    padding: "4px 8px",
    background: "no-repeat",
    borderRight: "none",
  },
  card: {
    // padding: 10,
    "&:hover": {
      // backgroundColor: "#ee8622",
      boxShadow: "rgb(149 157 165 / 20%) 0px 8px 24px",
    },
  },
}));
const SearchResult = () => {
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("sm"));
  const [open, setOpen] = React.useState(false);
  const { loading, holdresult } = useSelector((state) => state.home);
  const [header, SetHeader] = React.useState("onlineRecharge");
  useEffect(() => {
    if (location.state) {
      dispatch(HoldSearchDispatch(location.state.body));
    }
  }, []);
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handelHeader = (val) => {
    SetHeader(val);
  };
  const handleClose = () => {
    setOpen(false);
  };
  console.log("location", location);
  return (
    <div>
      <HeaderSection />
      <Box style={{ background: "rgb(15, 63, 90)", padding: 50 }}></Box>
      <Container
        style={{
          paddingLeft: matches ? 0 : 50,
          paddingRight: matches ? 0 : 50,
          paddingTop: 20,
        }}
      >
        <Box style={{ background: "#666", textAlign: "center", padding: 20 }}>
          <span
            style={{
              color: "white",
              fontFamily: "Open Sans,sans-serif",
              fontWeight: "bold",
              fontSize: 18,
            }}
          >
            {location.state.body.Segments[0].Origin} -{" "}
            {location.state.body.Segments[0].Destination}
          </span>
          <p style={{ color: "white", fontSize: 12 }}>
            {" "}
            {location.state.OriginO}
          </p>
        </Box>
      </Container>
      <Container
        style={{
          paddingLeft: matches ? 0 : 50,
          paddingRight: matches ? 0 : 50,
        }}
      >
        {loading
          ? Array.from(Array(5)).map((i) => {
              return <SkeletonOneway />;
            })
          : holdresult &&
            holdresult?.searchResult?.length > 0 &&
            holdresult?.searchResult?.map((i) => {
              return (
                <Box
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: 15,
                    border: "1px solid #dbdbdb",
                    marginTop: 20,
                    alignItems: "center",
                  }}
                  className={classes.card}
                >
                  <Box>
                    <img
                      src={`https://nitish.musafirbazar.com/static/media/${i.Segments[0].Airline.AirlineCode}.gif`}
                      width="50px"
                      height="50px"
                    ></img>
                    <span
                      style={{ marginLeft: 10 }}
                    >{`${i.Segments[0].Airline.AirlineName} ${i.Segments[0].Airline.FlightNumber}`}</span>
                  </Box>
                  <Box style={{ textAlign: "center" }}>
                    <span style={{ fontSize: 18 }}>{i.Origin}</span>
                    <p style={{ fontSize: 25 }}>
                      {i.Segments[0].Origin.DepTime.split("T")[1]}
                    </p>
                  </Box>
                  <Box style={{ textAlign: "center" }}>
                    <span style={{ color: "#ee8622" }}>
                      {i.Segments[0].Duration}
                    </span>
                    <p style={{ color: "#ee8622" }}>Direct</p>
                  </Box>
                  <Box style={{ textAlign: "center" }}>
                    <span style={{ fontSize: 18 }}>{i.Destination}</span>
                    <p style={{ fontSize: 25 }}>
                      {i.Segments[0].Destination.ArrTime.split("T")[1]}
                    </p>
                  </Box>
                  <Box style={{ textAlign: "center" }}>
                    <span style={{ fontSize: 18 }}>
                      ₹{Math.round(i.Fare.Total_Amount)}
                    </span>
                  </Box>
                  <Box
                    style={{ textAlign: "center", cursor: "pointer" }}
                    onClick={() =>
                      history.push({
                        pathname: "/summaryflight",
                        state: {
                          body: location.state.body,
                          selectedFlight: i,
                        },
                      })
                    }
                  >
                    <span
                      style={{
                        background: "#ee8622",
                        color: "white",
                        fontWeight: "bold",
                        padding: "10px",
                      }}
                    >
                      BOOK
                    </span>
                    <p style={{ marginTop: 10 }}>
                      Seat Left: {i.Segments[0].NoOfSeatAvailable}
                    </p>
                  </Box>
                </Box>
              );
            })}
      </Container>
      {/* <SlideDownModal
        open={open}
        handleClickOpen={handleClickOpen}
        handleClose={handleClose}
      /> */}
      <Footer />
    </div>
  );
};

export default SearchResult;
